<template>
  <div class="error-page">
    <img src="../../assets/404.jpg" alt="404" />
    <div class="error-pageText">
      <h2>抱歉，你没有权限去该页面......</h2>
      <div class="error-tips-text">
        <p>请检查你的帐号是否有权限</p>
      </div>
      <p class="btn-box">
        <el-button type="text" @click="back">返回上一页</el-button>
      </p>
      <p class="btn-box">
        <el-button type="primary" @click="toHome">去首页</el-button>
      </p>
      <p class="btn-box">
        <el-button type="primary" @click="logout">重新登录</el-button>
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Page401',
  methods: {
    back() {
      if (this.$route.query.noGoBack && this.$store.state.permission.defaultRoute) {
        this.$router.push({
          name: this.$store.state.permission.defaultRoute.name
        })
      } else {
        this.$router.go(-1)
      }
    },
    toHome() {
      const { defaultRoute = {} } = this.$store.state.permission
      const { name = '' } = defaultRoute
      if (name) {
        this.$router.push({
          name
        })
      } else {
        this.$router.push({
          path: '/'
        })
      }
    },
    logout() {
      this.$store.dispatch('user/logout')
      this.$store.dispatch('tagsView/delAllViews')
      window.IM && window.IM.destroy()
    }
  }
}
</script>

<style lang="css" scoped>
.error-page {
  width: 880px;
  margin: 280px auto 0;
}
.error-page img {
  float: left;
}
.error-page .error-pageText {
  float: left;
  margin-left: 104px;
}
.error-tips-text {
  font-size: 14px;
  padding: 10px 0;
  margin-bottom: 20px;
  line-height: 25px;
}
.error-page .error-pageText h2 {
  margin: 40px 0 31px;
  font-size: 30px;
  color: #333;
}
.error-page .error-pageText .back {
  width: 120px;
  height: 37px;
  background: #e32530;
  color: #fff;
  text-align: center;
  line-height: 37px;
  display: inline-block;
  text-decoration: none;
  font-size: 18px;
}
.error-page .error-pageText .back:hover {
  opacity: 0.9;
}
.error-page .error-pageText .in {
  color: #333;
  font-size: 18px;
  margin-left: 20px;
  text-decoration: none;
}
.error-page .error-pageText .in:hover {
  color: #e32530;
}
.btn-box {
  text-align: center;
  margin-bottom: 15px;
}
</style>
